// extracted by mini-css-extract-plugin
export default {"infoKeyCell":"ProductInfoPopover_infoKeyCell__COFzD","infoContentCell":"ProductInfoPopover_infoContentCell__te8ws"};